import { useCallback } from "react";
import { useFragment } from "react-relay";
import { graphql } from "react-relay";

import { copyToClipboard } from "~/lib/utils";
import toast from "~/ui/toast";

import type { useCopyMeetingLink_note$key } from "~/__generated__/useCopyMeetingLink_note.graphql";

export function useCopyMeetingLink(noteKey: useCopyMeetingLink_note$key) {
	const note = useFragment(
		graphql`
			fragment useCopyMeetingLink_note on Note {
				id
				hasMeetingRecordings
				meetingRecordingLink {
					id
					urlForCopy: url(forCopy: true)
				}
				shortUrl
			}
		`,
		noteKey,
	);

	return useCallback(async () => {
		if (note.hasMeetingRecordings) {
			await copyToClipboard(note.meetingRecordingLink.urlForCopy);
		} else {
			await copyToClipboard(note.shortUrl);
		}
		toast.success("Link copied to clipboard");
	}, [note.hasMeetingRecordings, note.meetingRecordingLink.urlForCopy, note.shortUrl]);
}
